// All types are snapshots from the V4 form progress state in order to be independent of the auto-generated code and application logic.

export enum Payer {
    Self = 'self',
    Other = 'other',
}

enum Page {
    OrderDetails = 'OrderDetails',
    Login = 'Login',
    Registration = 'Registration',
    PaymentOptions = 'PaymentOptions',
    Payment = 'Payment',
    StartDate = 'StartDate',
    Confirmation = 'Confirmation',
}

interface Money {
    amount: number;
    currencyCode: string;
    currencySymbol: string;
}

interface OnlineStudySubject {
    code: string;
    name: string;
    educationCategories: string[];
    credits: number;
    creditsLabel: string;
    price: Money;
    url: string;
    startDate?: string;
}

interface OrderedSubjectItem {
    subject: OnlineStudySubject;
    subjectCode: string;
    subjectName: string;
    subjectCredits: number;
    subjectCreditsLabel: string;
    subjectOriginalPrice: Money;
    startDate?: string;
}

interface Installments {
    numberOfInstallments: number;
}

interface InvoiceOtherPayer {
    name: string;
    address: string;
    postalCode: string;
    organizationNumber: string;
    city: string;
    contactPersonName: string;
    contactPersonPhone: string;
    contactPersonEmail: string;
}

interface InvoiceSelfPaid {
    additionalFee: Money;
    paymentDueDays: number;
}

interface Invoice {
    payer: Payer;
    otherPayer?: InvoiceOtherPayer;
    selfPaid?: InvoiceSelfPaid;
}

interface OnlineApplicationOrder {
    orderReference: string;
    orderedSubjectItems: OrderedSubjectItem[];
    payeeReference: string;
    isPaid: boolean;
    discountCode: string;
    parentStudyCode: string;
    totalPoints: number;
    totalScotcat: number;
    personalInfo: PersonalInfo;
    withLoanFund: boolean;
    isFree: boolean;
    installments?: Installments;
    invoice?: Invoice;
    creditCard?: object;
    totalPrice?: Money;
    originalPrice?: Money;
    totalDiscount?: Money;
    additionalFee?: Money;
}

interface PaymentMethod {
    isSupportedByPayEx: boolean;
    isInvoicePaymentOptionEnabled: boolean;
    isInstallmentsPaymentOptionEnabled: boolean;
    isCreditCardPaymentOptionEnabled: boolean;
    priceType?: string;
    urlPart?: string;
}

export interface PersonalInfo {
    firstName: string;
    lastName: string;
    personalNumber: string;
    phoneCountryCode: string;
    phoneNumber: string;
    email: string;
    address: string;
    postalCode: string;
    postOffice: string;
    privacyConsent: boolean;
    countryCode: string;
    repeatedEmail?: string;
    isFormerStudent?: boolean;
}

export interface ApplicationFormProgressState {
    paymentMethod: PaymentMethod;
    onlineStudiesTermsConsent: boolean;
    dataProtectionConsent: boolean;
    order: Partial<OnlineApplicationOrder>;
    activePage: Page;
    version: 'v4';
    paymentResourceUri?: string;
}
